import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from 'views/HomePage.vue';
import HomeGrid from 'views/HomeGrid.vue';
import SoftwareInstall from 'views/software/SoftwareInstall.vue';
import SoftUpgrade from 'views/software/SoftwareUpgrade.vue';
import SoftwareDeploy from 'views/software/SoftwareDeploy.vue';
import SystemInfo from 'views/modules/SystemInfo.vue';
import DebugPage from 'views/DebugPage.vue';
import ErrorPage from 'views/ErrorPage.vue';
import HomeCheck from 'views/modules/HomeCheck.vue';
import BrowserFix from 'views/modules/BrowserFix.vue';
import PcOptimize from 'views/modules/PcOptimize.vue';
import ServiceCenter from 'views/modules/ServiceCenter.vue';
import SoftwareApplication from 'views/software/SoftwareApplication.vue';
import SoftwareApply from 'views/software/SoftwareApply.vue';
import DiskClear from 'views/modules/DiskClear.vue';
import SoftwareUninstall from 'views/software/SoftwareUninstall.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: HomePage,
    children: [
      {
        path: '/home_grid',
        component: HomeGrid,
      },
      {
        path: '/SoftwareInstall',
        component: SoftwareInstall,
      },
      {
        path: '/software_upgrade',
        component: SoftUpgrade,
      },
      {
        path: '/software_deploy',
        component: SoftwareDeploy,
      },
      {
        path: '/system_info',
        component: SystemInfo,
      },
      {
        path: '/home_check',
        component: HomeCheck,
      },
      {
        path: '/softapplication',
        component: SoftwareApplication,
      },
      {
        path: '/softapply',
        component: SoftwareApply,
      },
      {
        path: '/browser_fix',
        component: BrowserFix,
      },
      {
        path: '/pc_optimize',
        component: PcOptimize,
      },
      {
        path: '/service_center',
        component: ServiceCenter,
      },
      {
        path: '/error',
        component: ErrorPage,
      },
      {
        path: '/debug',
        component: DebugPage,
      },
      {
        path: '/disk_clear',
        component: DiskClear,
      },
      {
        path: '/software_uninstall',
        component: SoftwareUninstall,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  // eslint-disable-next-line no-undef
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(`from: ${from.path}, to: ${to.path}`);
  return next();
});

/* to resolve the ElementUI nav double click error */
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
